import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-block",
    padding: 0,
    margin: 0,
    width: "100%",
  },

  label: {
    marginBottom: theme.hv.spacing.xs,
    float: "left",
  },

  description: {
    float: "left",
  },

  list: {
    display: "flex",
    alignContent: "flex-start",
    float: "left",
    clear: "both",
    width: "100%",
    padding: 5,

    minWidth: 320,
    minHeight: 66,
    maxWidth: "100%",
    resize: "both",
    overflow: "auto",

    flexDirection: "row",
    flexWrap: "wrap",

    backgroundColor: theme.hv.palette.atmosphere.atmo1,
    border: `1px solid ${theme.hv.palette.atmosphere.atmo4}`,
    borderRadius: "2px",

    "&:focus": {
      outline: "none",
    },

    "&:focus-visible": {
      outlineColor: "#52A8EC",
      outlineStyle: "solid",
      outlineWidth: "0px",
      outlineOffset: "-1px",
      boxShadow: "0 0 0 1px #52A8EC, 0 0 0 4px rgba(29,155,209,.3)",
    },

    "&:focus-within, &:hover": {
      border: `1px solid ${theme.hv.palette.accent.acce1}`,
    },

    "&$disabled": {
      backgroundColor: theme.hv.palette.atmosphere.atmo3,
      border: `1px solid ${theme.hv.palette.atmosphere.atmo4}`,

      "&:focus-within, &:hover": {
        border: `1px solid ${theme.hv.palette.atmosphere.atmo4}`,
      },
    },
  },
  listItem: {
    padding: 5,
    height: "auto",
    lineHeight: "16px",
  },
  tag: {
    maxWidth: "initial",
  },

  disabled: {
    cursor: "not-allowed",
  },
  invalid: {
    "&:not($disabled)": {
      border: `1px solid ${theme.hv.palette.semantic.sema4}`,
    },
  },
  canShowError: {
    "&:not($invalid)": {
      marginBottom: 32,
    },
  },

  error: {
    width: "100%",
    float: "left",
    clear: "both",
  },
}));

export default useStyles;
